module.exports = __webpack_public_path__ + "c1fb86e30726d4969fec87f7acf5723e.svg";